import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function Products() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/products").then(r => setItems(r.data)); }, []);

  const filtered = items.filter(
    (p) => p.name.toLowerCase().includes(q.toLowerCase()) || p.category.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div className="mx-auto max-w-7xl px-6 py-16">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-teal-700">Catalog</div>
          <h1 className="mt-3 text-4xl font-bold tracking-tight text-[#0F2942] sm:text-5xl" style={{ fontFamily: "Outfit, sans-serif" }}>{t("nav.products")}</h1>
        </div>
        <div className="relative w-full max-w-sm">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input data-testid="products-search" placeholder="Search equipment or category…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
        </div>
      </div>

      <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filtered.map((p) => (
          <Link key={p.id} to={`/products/${p.id}`} data-testid={`product-card-${p.id}`}
                className="group overflow-hidden rounded-xl border border-slate-200 bg-white transition-all hover:-translate-y-1 hover:shadow-xl">
            <div className="aspect-[4/3] overflow-hidden bg-slate-100">
              {p.images?.[0] && <img src={p.images[0]} alt={p.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}
            </div>
            <div className="p-5">
              <div className="text-xs font-semibold uppercase tracking-wider text-teal-700">{p.category}</div>
              <h3 className="mt-2 line-clamp-2 text-base font-semibold text-[#0F2942]">{p.name}</h3>
              <p className="mt-2 line-clamp-2 text-xs text-slate-500">{p.description}</p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-sm font-bold text-[#0F2942]">
                  {p.price_on_request ? t("product.por") : `₹ ${p.price?.toLocaleString("en-IN")}`}
                </span>
                <span className="rounded-full bg-teal-50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-teal-700">New</span>
              </div>
            </div>
          </Link>
        ))}
        {filtered.length === 0 && (
          <div className="col-span-full py-12 text-center text-slate-500">No products found.</div>
        )}
      </div>
    </div>
  );
}
